import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCross = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12 1.41405L10.5859 0L5.99998 4.58593L1.41405 0L0 1.41405L4.58593 5.99998L0 10.5859L1.41405 12L5.99998 7.41407L10.5859 12L12 10.5859L7.41407 5.99998L12 1.41405Z",
		fill: "#5B5F7B"
	})
});
export default SvgCross;
